/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_End_TimeInputs */



/**
* | output |
* | --- |
* | "Include End Time" |
*
* @param {Transcript_Export_Include_End_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_end_time = /** @type {((inputs?: Transcript_Export_Include_End_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_End_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure l'heure de fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endzeit einschließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi ora di fine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Укажите время окончания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir hora de finalización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包括结束时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時間を含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति समय शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir horário de término")
	return /** @type {LocalizedString} */ ("Include End Time")
});